import * as Enums from '../enums/general';

export default class mdSpinnerConfig {
    bdColor: string;
    size: Enums.SpinnerSize;
    color: string;
    type: string;
}